<template>
  <section id="state-results">
    <div class="row clearfix">
      <h1>Individual State Results</h1>

      <ul>
        <li id="nsw">
          <h3>
            <a href="javascript:;" v-scroll-to="'#nsw-results'"><img src="@/assets/img/2018/map-nsw.png">
              New South Wales
            </a>
          </h3>
        </li>
        <li id="vic">
          <h3>
            <a href="javascript:;" v-scroll-to="'#vic-results'"><img src="@/assets/img/2018/map-vic.png">
              Victoria
            </a>
          </h3>
        </li>
        <li id="qld">
          <h3>
            <a href="javascript:;" v-scroll-to="'#qld-results'"><img src="@/assets/img/2018/map-qld.png">
              Queensland
            </a>
          </h3>
        </li>
        <li id="wa">
          <h3>
            <a href="javascript:;" v-scroll-to="'#wa-results'"><img src="@/assets/img/2018/map-wa.png">
              Western Australia
            </a>
          </h3>
        </li>
        <li id="sa">
          <h3>
            <a href="javascript:;" v-scroll-to="'#sa-results'"><img src="@/assets/img/2018/map-sa.png">
              South Australia
            </a>
          </h3>
        </li>
        <li id="act">
          <h3>
            <a href="javascript:;" v-scroll-to="'#act-results'"><img src="@/assets/img/2018/map-act.png">
              Australian Capital Territory
            </a>
          </h3>
        </li>
        <li id="tas">
          <h3>
            <a href="javascript:;" v-scroll-to="'#tas-results'"><img src="@/assets/img/2018/map-tas.png">
              Tasmania
            </a>
          </h3>
        </li>
        <li id="nt">
          <h3>
            <a href="javascript:;" v-scroll-to="'#nt-results'"><img src="@/assets/img/2018/map-nt.png">
              Northern Territory
            </a>
          </h3>
        </li>
      </ul>

      <NSWResults></NSWResults>
      <VICResults></VICResults>
      <QLDResults></QLDResults>
      <WAResults></WAResults>
      <SAResults></SAResults>
      <ACTResults></ACTResults>
      <TASResults></TASResults>
      <NTResults></NTResults>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
import NSWResults from './Results/NSW'
import VICResults from './Results/VIC'
import QLDResults from './Results/QLD'
import WAResults from './Results/WA'
import SAResults from './Results/SA'
import ACTResults from './Results/ACT'
import TASResults from './Results/TAS'
import NTResults from './Results/NT'

export default {
  components: {
    NSWResults,
    VICResults,
    QLDResults,
    WAResults,
    SAResults,
    ACTResults,
    TASResults,
    NTResults,
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
